import PropTypes from 'prop-types';
import React, {Component} from 'react';

import {Power3, TweenLite} from "gsap";
import ReactDOM from 'react-dom'
import {TransitionGroup} from 'react-transition-group'

class FadingItem extends Component {

    static propTypes = {
        fadeOutAnimation: PropTypes.bool,
        fadeInAnimation: PropTypes.bool,
        appearAnimation: PropTypes.bool,
        appearDelay: PropTypes.number
    }

    componentWillAppear(callback) {
        if (!this.props.appearAnimation) {
            callback()
        } else {
            const dom = ReactDOM.findDOMNode(this)
            if (!dom) {
                callback()
                return
            }
            TweenLite.set(dom, {clearProps: "all"});
            TweenLite.fromTo(dom, 0.75, {opacity: 0, y: -10}, {delay: this.props.appearDelay, y: 0, ease: Power3.easeInOut, opacity: 1, onComplete: callback})
        }
    }

    componentWillEnter(callback) {
        const dom = ReactDOM.findDOMNode(this)
        if (!dom) {
            callback()
            return
        }
        TweenLite.set(dom, {clearProps: "all"});
        TweenLite.from(dom, this.props.fadeInAnimation ? 0.4 : 0, {ease: Power3.easeOut, opacity: 0, onComplete: callback})
    }

    componentWillLeave(callback) {
        const dom = ReactDOM.findDOMNode(this)
        if (!dom) {
            callback()
            return
        }
        TweenLite.set(dom, {clearProps: "all"});
        TweenLite.to(dom, this.props.fadeOutAnimation ? 0.4 : 0, {ease: Power3.easeOut, opacity: 0, onComplete: callback})
    }

    componentWillUnmount() {
        const dom = ReactDOM.findDOMNode(this)
        if (!dom) {
            return
        }
        TweenLite.killTweensOf(dom)
        TweenLite.set(dom, {clearProps: "all"});
    }

    render() {
        return this.props.children
    }

}

function FadingTransitionGroup(props) {

    let fadingChildren = React.Children.map(props.children,
        (child) => {
            return child ? <FadingItem
                key={props.key}
                fadeOutAnimation={props.fadeOutAnimation}
                fadeInAnimation={props.fadeInAnimation}
                appearAnimation={props.appearAnimation}
                appearDelay={props.appearDelay}
            >{child}
            </FadingItem> : null;
        }
    )

    return (
        <TransitionGroup {...{component: props.component, childFactory: props.childFactory}}>
            {fadingChildren}
        </TransitionGroup>
    );
}

FadingTransitionGroup.propTypes = {
    ...TransitionGroup.propTypes,
    fadeOutAnimation: PropTypes.bool,
    fadeInAnimation: PropTypes.bool,
    appearAnimation: PropTypes.bool,
    appearDelay: PropTypes.number
};

FadingTransitionGroup.defaultProps = {
    ...TransitionGroup.defaultProps,
    fadeOutAnimation: true,
    fadeInAnimation: true,
    appearAnimation: false,
    appearDelay: 0
};

export default FadingTransitionGroup


/** WEBPACK FOOTER **
 ** ./src/components/FadingTransitionGroup.js
 **/